import './src/styles/global.css'

import React from 'react'
import { UserProvider } from './src/components/shared/UserContext'

export const wrapPageElement = ({ element }) => {
  return <UserProvider>{element}</UserProvider>
}
